import translationsEn from 'assets/translations/en-GB.json';
import translationsPl from 'assets/translations/pl-PL.json';
import translationsIt from 'assets/translations/it-IT.json';
import translationsBg from 'assets/translations/bg-BG.json';
import translationsNl from 'assets/translations/nl-NL.json';
import translationsDE from 'assets/translations/de-DE.json';
import plPl from 'antd/lib/locale/pl_PL';
import enGb from 'antd/lib/locale/en_GB';
import itIt from 'antd/lib/locale/it_IT';
import bgBg from 'antd/lib/locale/bg_BG';
import nlNl from 'antd/lib/locale/nl_NL';
import deDe from 'antd/lib/locale/de_DE';
import { Locale } from 'antd/lib/locale-provider';
import { Locale as DateFnsLocale } from 'date-fns';
import { enGB, it, pl, bg, nl, de } from 'date-fns/locale';
export enum LanguageName {
  EN = 'en',
  IT = 'it',
  PL = 'pl',
  BG = 'bg',
  NL = 'nl',
  DE = 'de',
}

export interface AppLanguage {
  name: LanguageName;
  code: string;
  translations: any;
  antdLocale: Locale;
}

// Not defining locale key as LanguageName because it is locale value from antd locales
// refer to lib/antd/pickerGenerateDateFns dealLocal (small caps without dialect)
// todo: potential optimization via lazy load
export const dateFnsLocale: Record<string, DateFnsLocale> = {
  pl: pl,
  en: enGB,
  it: it,
  bg: bg,
  nl: nl,
  de: de,
};

export const defaultLanguage = {
  name: LanguageName.EN,
  code: 'en-GB',
  translations: translationsEn,
  antdLocale: enGb,
};

export const languages = [
  defaultLanguage,
  {
    name: LanguageName.PL,
    code: 'pl-PL',
    translations: translationsPl,
    antdLocale: plPl,
  },
  {
    name: LanguageName.IT,
    code: 'it-IT',
    translations: translationsIt,
    antdLocale: itIt,
  },
  {
    name: LanguageName.BG,
    code: 'bg-BG',
    translations: translationsBg,
    antdLocale: bgBg,
  },
  {
    name: LanguageName.NL,
    code: 'nl-NL',
    translations: translationsNl,
    antdLocale: nlNl,
  },
  {
    name: LanguageName.DE,
    code: 'de-DE',
    translations: translationsDE,
    antdLocale: deDe,
  },
];

export const languageStorageKey = 'HIGO-language';
